import Vue from 'vue'
import Vuex from 'vuex'
import globle from './globle'
import homePage from './homePage'
import recordPage from './recordPage'

Vue.use(Vuex)
export default new Vuex.Store({
    modules: {
        globle,
        homePage,
        recordPage
    }
})